// apps/client/src/ui/creator/SwatchRow.tsx (M0-T16) — a row of choices; swatches show their colour, choices their name
import type { StringKey } from '@whiskerton/content';
import type { CSSProperties } from 'react';
import { useT } from '../i18n';

export function SwatchRow(p: { label: string; options: readonly { id: string; name: string; hex?: string }[]; value: string; onPick: (id: string) => void }) {
  const t = useT();
  return (
    <fieldset className="swatch-row">
      <legend>{p.label}</legend>
      {p.options.map((o) => (
        <button key={o.id} type="button" className="swatch hit" aria-pressed={o.id === p.value} aria-label={t(o.name as StringKey)}
          style={o.hex ? ({ '--swatch': o.hex } as CSSProperties) : undefined} onClick={() => p.onPick(o.id)}>
          {o.hex ? null : t(o.name as StringKey)}
        </button>
      ))}
    </fieldset>
  );
}
